import { makeBooleanFlagValueHook } from '#pplx/frontend/experimentation/hooks.js';
export const useModelConfigReadinessFromQueryStateVariation = makeBooleanFlagValueHook('model-config-readiness-from-query-state');
//# sourceMappingURL=useModelConfigReadinessFromQueryStateVariation.js.map